const riot = require('riot');

riot.tag2('page-distribution-rules-single', '<div class="f"> <div class="h100vh sticky t0" data-is="module-sidebar"></div> <form class="w-full f fclm bg-pale_gray" if="{isShow}" onsubmit="{onSubmit}"> <div data-is="module-page-header" back="/app/companies/{companyId}/projects/{projectId}/campaigns/{campaign.id}" title="{distributionRule.name}" breadcrumbs="{breadcrumbs}"> <yield to="badge"> <div class="flex-fixed" data-is="atom-distribution_rule_status-badge" item="{parent.distributionRule}"></div> </yield> <yield to="right"> <div class="f fh flex-fixed"> <button class="hide"></button> <button class="button mr12" if="{parent.shouldShowUpdateButton()}">{(parent.isRaffle(parent.distributionTargetStrategies[0]) && parent.distributionRule.status === ⁗published⁗)  ? ⁗保存⁗ : ⁗下書き保存⁗}</button> <button class="button primary" if="{parent.distributionRule.status === &quot;draft&quot;}" onclick="{parent.changeSubmitFlag}">公開</button> </div> </yield> </div> <div class="f fclm px40 py36"> <div class="mb32" if="{isPublished()}" data-is="module-event-list" distribution-point-strategy="{distributionPointStrategies[0].point_provider}" distribution-target-strategy="{distributionTargetStrategies[0]}" distribution-rule="{distributionRule}" raffle-rule="{raffleRule}" disabled="{shouldDisableCSVButton()}" on-start-import-job="{onStartImportJob}" on-start-export-job="{onStartExportJob}"></div> <div class="mb32" if="{isPublished()}" data-is="module-job-list" distribution-target-strategy="{distributionTargetStrategies[0]}" distribution-rule="{distributionRule}" raffle-rule="{raffleRule}" current="{importExportCurrent}" export-jobs="{exportJobs}" import-jobs="{importJobs}" import-pagination="{importPagination}" export-pagination="{exportPagination}"></div> <div class="section-padding rounded-8 elevation-default-low bg-white mb32" if="{distributionTargetStrategies[0].distribution_target_type === &quot;all&quot; &amp;&amp; isPublished()}"> <div class="mb36" data-is="module-section-header" title="発行済み金額"></div> <div class="ts-pm text-navy">{distributionRule.consumed_point.toLocaleString()}円</div> </div> <div class="f fclm rounded-8 elevation-default-low bg-white section-padding mb32" if="{distributionTargetStrategies[0].distribution_target_type === &quot;raffle&quot; &amp;&amp; (isPublished() || isArchived())}"> <div class="mb24" data-is="module-section-header" title="抽選設定と発行済み金額"></div> <div data-is="atom-input-raffle-patterns" ref="rafflePatterns" if="{raffleResultPatterns &amp;&amp; raffleRule}" patterns="{raffleResultPatterns}" is-edit="{true}" readonly="{isArchived() || !app.utils.permission.has(&quot;project_writer&quot;, { company_id: distributionPointStrategies[0].company.id, project_id: distributionPointStrategies[0].project.id})}" is-all-win="{refs.is_all_win.checked}"></div> </div> <div class="f fclm section-padding rounded-8 bg-white elevation-default-low mb32"> <div class="mb36" data-is="module-section-header" title="基本設定"></div> <label class="block mb24"> <div class="f fm mb8"> <div class="ts-hxs mr4 {isModifiable ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">配布ルール名</div> <div class="ts-hxxs text-pink_70" if="{isModifiable}">必須</div> </div> <input class="input w-full" if="{isModifiable}" ref="name" type="text" required placeholder="配布ルール名を入力" readonly="{!isModifiable}" riot-value="{!isNew ? distributionRule.name : &quot;&quot;}" oninput="{changeData}"> <div class="ts-pm text-navy" if="{!isModifiable}">{distributionRule.name}</div> </label> <div class="mb24"> <div class="f fm mb8"> <div class="ts-hxs mr4 {isModifiable ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">ポイント配布方法</div> </div> <div class="ts-pm text-navy">{getLabel(app.data.constants.distribution_target_types, distributionTargetStrategies[0].distribution_target_type)}</div> </div> <div class="mb24"> <div class="f fm mb8"> <div class="ts-hxs mr4 {isModifiable ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">ポイントサービス</div> <div class="ts-hxxs text-pink_70" if="{isModifiable}">必須</div> </div> <div class="f fm mb8" if="{isModifiable}"> <label class="f fm cursor-pointer mr12 mr0-last" each="{option, i in radioOptions}"> <input class="radio mr8" ref="radio" type="radio" riot-value="{option.id}" name="select" onchange="{onChangeOption}" checked="{option.checked}"> <div class="ts-ps text-navy">{option.label}</div> </label> </div> <div class="ts-pxs text-gray_60 mb8">配布するポイントのサービスを選択できます</div> <div class="w500" if="{isModifiable &amp;&amp; !pointProviderSelectionEnabled}" data-is="atom-input-select" ref="point_provider_pull_down" options="{providerOptionsWithTest}" disabled="{!isModifiable}" oninput="{onInputProvider}" riot-value="{distributionPointStrategies[0].point_provider}" required></div> <div if="{isModifiable &amp;&amp; pointProviderSelectionEnabled}"> <div each="{option in providerOptions}"> <label class="f fm cursor-pointer mb8"> <input class="checkbox mr10" ref="point_provider_checkbox" type="checkbox" riot-value="{option.id}" onchange="{onChangeSelectedProvider}" checked="{selectedProviderIds.includes(option.id)}"> <div>{option.name}</div> </label> </div> </div> <ul> <li class="ts-pm text-navy list-position-inside mb4 mb0-last" if="{!isModifiable}" each="{strategy in distributionPointStrategies}">{getLabel(app.data.constants.point_providers, strategy.point_provider)}</li> </ul> </div> <div class="mb24" if="{!pointProviderSelectionEnabled}"> <div class="f fm mb8"> <div class="ts-hxs text-gray_80 mr4 {isModifiable ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">ポイント付与回数の制限</div> </div> <div class="ts-pxs text-gray_60 mb8">同じPayPayアカウントがこの配布ルールによる特典を何度も受け取れないよう制限できます。この設定はPayPayの場合のみ有効です。</div> <label class="f fm" if="{isModifiable}"> <input class="checkbox mr10" ref="no_duplicate_account" type="checkbox" onchange="{onChangeNoDuplicateAccount}" disabled="{!refs.point_provider_pull_down.getValue() || refs.point_provider_pull_down.getValue() !== &quot;paypay&quot;}" checked="{noDuplicateAccountChecked}"> <div class="ts-ps text-navy cursor-pointer">1アカウントあたり1回までに制限</div> </label> <div if="{!isModifiable}">{distributionRule.no_duplicate_account ? ⁗1アカウントあたり1回までに制限⁗ : ⁗制限しない⁗}</div> </div> <div> <div class="ts-hxs mb8 {isModifiable ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">自動アーカイブ設定</div> <div class="ts-pxs text-gray_60 mb8">システム負荷軽減のため配布ルールは自動でアーカイブされます。<br>この配布ルールで配布を行なう期間の末日から90日以上の日付が設定できます。<br>APIでの利用など、この配布ルールを恒常的に利用する場合はアーカイブ日を指定しないを選択してください。</div> <div class="f fm" if="{isModifiable}"> <input class="input cursor-pointer mr12" ref="archive_date" min="{dayjs().add(90, &quot;d&quot;).format(&quot;YYYY-MM-DD&quot;)}" riot-value="{distributionRule.archive_at ? dayjs(distributionRule.archive_at).format(&quot;YYYY-MM-DD&quot;) : null}" disabled="{refs.is_unset_archive.checked}" onchange="{changeData}" type="{\'date\'}"> <label class="f fm"> <input class="checkbox mr10" ref="is_unset_archive" type="checkbox" onchange="{changeData}" checked="{!distributionRule.archive_at}"> <div class="ts-ps text-navy cursor-pointer">アーカイブ日を指定しない</div> </label> </div> <div class="ts-pm text-navy" if="{!isModifiable}">{distributionRule.archive_at ? dayjs(distributionRule.archive_at).format(⁗YYYY-MM-DD⁗) : ⁗アーカイブ日を指定しない⁗}</div> </div> </div> <div class="mb32" data-is="module-request-api" distribution-rule="{distributionRule}" distribution-target-strategy="{distributionTargetStrategies[0]}" distribution-point-strategy="{distributionPointStrategies[0]}"></div> <div class="mb32" data-is="module-webhook-list" distribution-rule="{distributionRule}" disabled="{!app.utils.permission.has(&quot;project_writer&quot;, { company_id: companyId, project_id: projectId })}"></div> <div class="f fclm rounded-8 elevation-default-low bg-white section-padding mb32" if="{distributionTargetStrategies[0].distribution_target_type === &quot;raffle&quot;}"> <div class="mb60" data-is="module-section-header" title="抽選設定"></div> <div class="mb32"> <div class="ts-hs text-navy mb32">抽選期間</div> <label class="f fm mb32" show="{isModifiable}"> <input class="checkbox mr10" ref="is_all_win" type="checkbox" onchange="{changeData}" checked="{raffleRule.is_allwin}"> <div class="ts-ps text-navy cursor-pointer">抽選結果から「ハズレ」を取り除く</div> </label> <div class="f fm mb8"> <div class="ts-hxs mr4 {!isArchived() ? &quot;text-gray_80&quot; : &quot;text-gray_30&quot;}">抽選の終了日</div> <div class="ts-hxxs text-pink_70" if="{!isArchived()}">必須</div> </div> <div class="ts-pxs text-gray_60 mb8">設定された日の23:59までがユーザーが抽選できます。以降は抽選ができなくなります</div> <input class="input w160 cursor-pointer" if="{!isArchived()}" min="{dayjs().format(&quot;YYYY-MM-DD&quot;)}" max="{getMaxOfCloseAt()}" riot-value="{dayjs(raffleRule.close_at).format(&quot;YYYY-MM-DD&quot;)}" oninput="{refs.rafflePreview.bindRaffleRule(&quot;close_at&quot;, &quot;general&quot;)}" type="{\'date\'}"> <div class="ts-ps text-navy" if="{isArchived()}">{dayjs(raffleRule.close_at).format(⁗YYYY/M/D⁗)}</div> </div> <div class="mb32" if="{!(isPublished() || isArchived())}"> <div class="ts-hs text-navy mb32">抽選配分</div> <div data-is="atom-input-raffle-patterns" ref="rafflePatterns" if="{raffleResultPatterns &amp;&amp; raffleRule}" patterns="{raffleResultPatterns}" readonly="{isArchived()}" point-providers="{pointProviderSelectionEnabled ? selectedProviderIds : [].concat(selectedFixedProviderId || [])}" is-all-win="{refs.is_all_win.checked}"></div> </div> <div class="mb32"> <div class="ts-hs text-navy mb20">画面カスタマイズ</div> <p class="ts-pxs text-gray_60 mb28">ユーザーが引いた抽選結果ごとに出す画面のカスタマイズができます<br>くじびき抽選を行う画面「抽選画面」のカスタマイズができます</p> <div data-is="atom-input-raffle-preview" if="{raffleResultPatterns &amp;&amp; raffleRule}" ref="rafflePreview" length="{refs.rafflePatterns.getPatternsLength()}" campaign="{campaign}" readonly="{isArchived()}" general="{raffleRule}" rules="{raffleResultPatterns}" is-all-win="{refs.is_all_win.checked}"></div> </div> </div> </div> </form> </div>', 'page-distribution-rules-single,[data-is="page-distribution-rules-single"]{display:block}', '', function(opts) {

    this.isLoading = true;

    this.limit = 50;

    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      this.isLoading = true;
      var isModifiable = true;
      this.update();
      var companyId = req.params.company_id;
      var projectId = req.params.project_id;
      var campaign_id = req.params.campaign_id;
      var distribution_rule_id = req.params.distribution_rule_id;
      var query = {
        offset: 0,
        limit: this.limit,
        distribution_rule_id,
      };

      var promises = [
        app.api.child(`companies/${companyId}/projects/${projectId}/distribution_rules/${distribution_rule_id}`).get(),
        app.api.child(`companies/${companyId}/point_deposit_histories/summary`).get(),
        app.api.child(`companies/${companyId}/projects/${projectId}/campaigns/${campaign_id}`).get(),
        app.api.child(`companies/${companyId}/point_providers`).get(),
      ];
      var [{ distribution_rule }, { total_deposit_amount, total_consumed_amount }, { campaign }, { company_point_providers }] = await Promise.all(promises);

      isModifiable = (distribution_rule.status === "draft" && !distribution_rule.archived_at);

      this.providerOptionsWithTest = app.utils.getProviderOptionsWithTest(company_point_providers);

      this.providerOptions = app.utils.getProviderOptions(company_point_providers);

      this.pointProviderSelectionEnabled = distribution_rule.point_provider_selection_enabled;

      this.selectedFixedProviderId = distribution_rule.distribution_point_strategies[0].point_provider || '';

      this.selectedProviderIds = distribution_rule.distribution_point_strategies.map(s => s.point_provider);
      this.noDuplicateAccountChecked = distribution_rule.no_duplicate_account;

      this.radioOptions = [
        {
          id: 'fixed',
          label: 'ポイント種別を固定する',
          checked: !this.pointProviderSelectionEnabled,
        },
        {
          id: 'selectable',
          label: 'ユーザーがポイント種別を選択できる',
          checked: this.pointProviderSelectionEnabled,
        },
      ];

      var breadcrumbs = [
        {
          label: distribution_rule.project.name,
          link: `/app/companies/${companyId}/projects/${projectId}`,
        },
        {
          label: distribution_rule.campaign.name,
          link: `/app/companies/${companyId}/projects/${projectId}/campaigns/${campaign_id}`,
        }
      ];

      var detailButtons = [
        {
          type: 'button',
          text: '詳細',
          class: 'outline',
          onclick: () => this.onGoDistributionRuleEdit(),
        },
      ];

      this.isLoading = false;
      this.update();

      const project_ref = app.api.child(`companies/${companyId}/projects/${projectId}`);
      const jobArgs = {
        project_ref: project_ref,
        distribution_rule_id: distribution_rule_id,
        is_raffle: this.isRaffle(distribution_rule.distribution_target_strategies[0]),
        raffle_rule_id: distribution_rule.raffle_rule?.id,
      };

      await Promise.all([
        this.fetchImportJobs(jobArgs),
        this.fetchExportJobs(jobArgs),
      ]);

      return {
        companyId,
        projectId,
        campaign,
        distributionRule: distribution_rule,
        distributionPointStrategies: distribution_rule.distribution_point_strategies,
        distributionTargetStrategies: distribution_rule.distribution_target_strategies,
        raffleRule: distribution_rule.raffle_rule,
        raffleResultPatterns: distribution_rule.raffle_result_patterns,
        breadcrumbs,
        detailButtons,
        isModifiable,
        totalDepositAmount: total_deposit_amount,
        totalConsumedAmount: total_consumed_amount,
        projectRef: project_ref,
        importExportCurrent: 'import',
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title('配布ルール', this),
      };
    };

    this.on('show', () => {
      this.isUpdateDistributionRule = true;

      this.reset();
    });

    this.on('beforeunload', (e) => {
      if (this.isChange) {
        e.returnValue = app.data.beforeunload_text;
      }
    });

    this.on('datachange', () => {
      this.changeData();
      this.update();
    });

    this.on('addRafflePattern', ({ index }) => {
      this.refs.rafflePreview.addTab(index);
      this.raffleResultPatterns.splice(index, 0, {});
      this.update();
    });

    this.on('removeRafflePattern', ({ index }) => {
      this.refs.rafflePreview.removeTab(index);
      this.raffleResultPatterns.splice(index, 1);
    });

    this.onGoDistributionRuleEdit = () => {
      spat.router.push(`/app/companies/${this.companyId}/projects/${this.projectId}/campaigns/${this.campaign.id}/distribution_rules/${this.distributionRule.id}/edit`);
    };

    this.onSubmit = async (e) => {
      e.preventDefault();

      if (this.pointProviderSelectionEnabled && !this.selectedProviderIds.length) {
        spat.modal.alert('少なくとも1つ以上ポイントサービスを選択してください。');
        return ;
      }

      var indicator = spat.modal.indicator();
      try {

        if (this.isUpdateDistributionRule) {
          var success = await this.updateDistributionRule();
          if (!success) return ;
          this.isUpdateDistributionRule = true;
          spat.toast.message('更新しました');
        }

        else if (this.distributionRule.status === "draft") {
          var result = await app.utils.openModalDialog(
            {
              title: '公開しますか？',
              text: '公開をすると、配布ルールの編集ができなくなります。',
              size: 'small',
              negative_button_type: 'text',
              positive: '公開',
            }
          );
          if (!result) {
            this.isUpdateDistributionRule = true;
            return ;
          }
          var success = await this.updateDistributionRule();
          if (!success) return ;
          spat.toast.message('公開しました');
          this.isUpdateDistributionRule = true;
          this.reset();
        }
        this.isChange = false;

        this.isModifiable = (this.distributionRule.status === "draft" && !this.distributionRule.archived_at);
        this.update();
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
      }
      finally {
        indicator.close();
      }
    };

    this.updateDistributionRule = async () => {

      if (this.pointProviderSelectionEnabled) {
        this.noDuplicateAccountChecked = false
      }
      try {

        var query = {
          campaign_id: this.campaign.id,
        };
        if (this.isModifiable) {
          let point_providers = !this.pointProviderSelectionEnabled ? [].concat(this.selectedFixedProviderId || []) : this.selectedProviderIds;
          Object.assign(query, {
            name: this.refs.name.value,
            point_provider_selection_enabled: this.pointProviderSelectionEnabled,
            point_providers,
            archive_at:this.refs.is_unset_archive.checked ? 0 : dayjs(this.refs.archive_date.value).valueOf(),
            no_duplicate_account: this.noDuplicateAccountChecked,
          });
          if (!this.isUpdateDistributionRule) {
            Object.assign(query, {
              status: 'published'
            });
          }
        }

        if (this.distributionTargetStrategies[0].distribution_target_type === "raffle" && !this.isArchived()) {

          const raffle_patterns = this.refs.rafflePatterns.getValue();
          if (!raffle_patterns) return false;
          const image_api = app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules/signed_url_by_raffle_rule`);
          let [raffle_rule, patterns] = await this.refs.rafflePreview.getValue({ image_api });

          const raffle_result_patterns = this.raffleResultPatterns.map((p, i) => {
            return Object.assign({}, p, patterns[i], raffle_patterns[i]);
          });
          Object.assign(query, {
            raffle_rule,
            raffle_result_patterns,
          });
        }
        var { distribution_rule } = await app.api.child(`companies/${this.companyId}/projects/${this.projectId}/distribution_rules/${this.distributionRule.id}`).put(query);
        this.update({
          distributionRule: distribution_rule,
        });
        return true;
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message);
        return false;
      }
    };

    this.getTargetTypeLabel = () => {
      return app.data.distribution.target_types.find(type => type.id === this.distributionTargetStrategies[0].distribution_target_type).label;
    };

    this.getStatus = (rule) => {
      return app.data.constants.distribution_rule_statuses.find(status => status.id === rule.status);
    };

    this.getPointProviderName = (point_provider) => {
      return app.data.constants.point_providers.find(p => p.id === point_provider).name;
    };

    this.getLabel = (types, value) => {
      return types.find(t => t.id === value).name;
    };

    this.shouldShowUpdateButton = () => {

      if (!app.utils.permission.has('project_writer', { company_id: this.distributionPointStrategies[0].company.id, project_id: this.distributionPointStrategies[0].project.id})) return false;

      if (this.distributionTargetStrategies[0].distribution_target_type === "all") {
        return this.isModifiable;
      }
      else if (this.distributionTargetStrategies[0].distribution_target_type === "raffle") {
        return !this.distributionRule.archived_at;
      }
    };

    this.changeData = () => {
      this.isChange = true;
    };

    this.reset = () => {

      this.update({ isShow: false });
      this.update({
        isShow: true,
        isChange: false,
      });
    };

    this.onChangeOption = (e) => {
      let value = e.currentTarget.value;
      if (value === 'selectable') {
        this.pointProviderSelectionEnabled = true;
        this.noDuplicateAccountChecked = false;
      } else {
        this.pointProviderSelectionEnabled = false;
      }
      this.update();
    }

    this.onChangeSelectedProvider = (e) => {
      this.changeData();
      this.selectedProviderIds = [].concat(this.refs.point_provider_checkbox || []).filter(checkbox => checkbox.checked).map(input => input.value);
    };

    this.onChangeNoDuplicateAccount = (e) => {
      this.changeData();
      this.noDuplicateAccountChecked = e.currentTarget.checked;
    };

    this.changeSubmitFlag = () => {
      this.isUpdateDistributionRule = false;
    };

    this.isDraft = () => {
      return this.distributionRule.status === 'draft';
    };

    this.isArchived = () => {
      return !!this.distributionRule.archived_at;
    };

    this.isPublished = () => {
      return this.distributionRule.status === 'published';
    };

    this.getMaxOfCloseAt = () => {
      if (this.refs.archive_date) {

        return this.refs.is_unset_archive.checked ? null : this.refs.archive_date.value;
      }
      if (this.distributionRule.archive_at === 0) return null;
      return dayjs(distributionRule.archive_at).format("YYYY-MM-DD");
    };

    this.shouldDisableCSVButton = () => {

      var has_permission = app.utils.permission.has("project_writer", { company_id: this.companyId, project_id: this.projectId });

      if (this.distributionTargetStrategies[0].distribution_target_type === "all") {
        return !has_permission;
      }

      if (this.distributionPointStrategies[0].point_provider === "test_point_provider"){
        return false;
      }

      var company_balance = this.totalDepositAmount - this.totalConsumedAmount;
      var total_amount = this.calcBalance();
      var has_result_balance = company_balance >= total_amount;

      return !has_permission || !has_result_balance;
    };

    this.calcBalance = () => {

      var amount = 0;
      this.raffleResultPatterns.forEach(r => {
        amount += r.amount * (r.max_lot - r.consumed_lot);
      });
      return amount;
    };

    this.onInputProvider = () => {
      this.changeData();
      if (this.refs.point_provider_pull_down.getValue() !== 'paypay') {
        this.noDuplicateAccountChecked = false;
      }
    };

    this.onStartImportJob = () => {
      this.importExportCurrent = 'import';
      this.fetchImportJobs(this.defaultJobArgs());
      this.update();
    };

    this.onStartExportJob = () => {
      this.importExportCurrent = 'export';
      this.fetchExportJobs(this.defaultJobArgs());
      this.update();
    };

    this.on('importExportTabChange', (e) => {
      this.importExportCurrent = e.current;
      this.update();
    });

    this.refreshJobs = async () => {
      var indicator = spat.modal.indicator();
      try {
        await Promise.all([
          this.fetchImportJobs(this.defaultJobArgs()),
          this.fetchExportJobs(this.defaultJobArgs()),
        ]);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert(e.message)
      }
      finally {
        indicator.close();
      }
    };

    const DEFAULT_LIMIT = 50;

    this.defaultJobArgs = () => {
      return {
        project_ref: this.projectRef,
        distribution_rule_id: this.distributionRule.id,
        is_raffle: this.isRaffle(this.distributionTargetStrategies[0]),
        raffle_rule_id: this.raffleRule?.id,
      };
    };

    this.fetchImportJobs = async ({ project_ref, distribution_rule_id, is_raffle, raffle_rule_id='', offset=0, limit=DEFAULT_LIMIT }) => {
      try {
        const query = {
          offset: offset,
          limit: limit,
          distribution_rule_id: distribution_rule_id,
        }

        if (is_raffle) {
          query.raffle_rule_id = raffle_rule_id;
          var promises = [
            project_ref.child('raffle_events/import_jobs').get(query),
          ];
          var [{ raffle_event_import_jobs: importJobs, pagination: importPagination }] = await Promise.all(promises);
        }

        else {
          var promises = [
            project_ref.child('distribution_events/import_jobs').get(query),
          ];
          var [{ distribution_event_import_jobs: importJobs, pagination: importPagination }] = await Promise.all(promises);
        }

        this.importJobs = importJobs;
        this.importPagination = importPagination;
        this.update();
      }
      catch (e) {
        console.error(e.message);
        spat.modal.alert('イベント発行結果の取得に失敗しました');
      }
    };

    this.fetchExportJobs = async ({ project_ref, distribution_rule_id, is_raffle, raffle_rule_id='', offset=0, limit=DEFAULT_LIMIT }) => {
      try {
        const query = {
          offset: offset,
          limit: limit,
          distribution_rule_id: distribution_rule_id,
        }

        if (is_raffle) {
          query.raffle_rule_id = raffle_rule_id;
          var promises = [
            project_ref.child('raffle_onetime_hashes/export_jobs').get(query),
          ];
          var [{ raffle_onetime_hash_export_jobs: exportJobs, pagination: exportPagination }] = await Promise.all(promises);
        }

        else {
          var promises = [
            project_ref.child('onetime_hashes/export_jobs').get(query),
          ];
          var [{ onetime_hash_export_jobs: exportJobs, pagination: exportPagination }] = await Promise.all(promises);
        }

        this.exportJobs = exportJobs;
        this.exportPagination = exportPagination;
        this.update();
      }
      catch (e) {
        console.error(e.message);
        spat.modal.alert('エクスポート結果の取得に失敗しました');
      }
    };

    this.isRaffle = (distribution_target_strategy) => {
      return distribution_target_strategy.distribution_target_type === "raffle";
    };

    this.on('importPaginationChanged', async (e) => {
      var query = { ...this.defaultJobArgs(), ...e };
      await this.fetchImportJobs(query);
    });

    this.on('exportPaginationChanged', async (e) => {
      var query = { ...this.defaultJobArgs(), ...e };
      await this.fetchExportJobs(query);
    });

    this.on('onImportExportJobRefreshClicked', () => {
      this.refreshJobs();
      this.update();
    });
});